<template>
  <div>
    <div class="page-title">
      {{ $t('menu.account_settings') }}
    </div>
    <div class="page-container">

      <MerchantInfoItem />
      <div class="flex-justify-between">
        <div class="setting-item-label text-14-500">{{ $t('system.password') }}</div>
        <div class="setting-item-value">
          <el-button type="info" size="small" plain @click="onClickLoginChange"><img style="position: relative; top: 2px" height="13" src="data:image/png;base64,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"> {{ $t('system.change_your_password') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'System_User_Setting',
  components: {
    MerchantInfoItem: () => import('./components/MerchantInfoItem.vue')
  },
  mounted() {
    const { reset_type, account_type, naire_status, password_expire_time } = this.$store.state.user.userInfo
    if (reset_type === 2) {
      this.tipAndOpenPwdModal()
    }
    // else if (naire_status === 2 && account_type === 1) {
    //   this.tipAndOpenQuestionnaireModal()
    // }

    // this.checkPasswordExpireTime(password_expire_time)
  },
  // 不修改密码，老乡走不了
  // beforeRouteLeave(to, from, next) {
  //   if (to.path === '/questionnaire') {
  //     next()
  //     return
  //   }
  //   const { reset_type, account_type, naire_status, password_expire_time } = this.$store.state.user.userInfo
  //
  //   if (password_expire_time) {
  //     const dateNum = this.getDayDiff(password_expire_time)
  //
  //     if (dateNum <= 0) { // 密码到期强制修改密码
  //       // this.checkPasswordExpireTimeMustModify()
  //       return
  //     }
  //   }
  //
  //   if (this.$router) {
  //     if (reset_type === 2) {
  //       this.tipAndOpenPwdModal()
  //     } else if (naire_status === 2 && account_type === 1) {
  //       this.tipAndOpenQuestionnaireModal()
  //       next()
  //     } else {
  //       next()
  //     }
  //   }
  // },

  methods: {
    tipAndOpenPwdModal() {
      this.$confirm('You must change your password before you can use the system', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.showPwdModal()
      })
    },
    showPwdModal() {
      this.$store.commit('user/SET_MODTIFY_PWD_STATUS', true)
    },
    tipAndOpenQuestionnaireModal() {
      this.$alert('You must finish the Compliance Questionnaire before you activate the account', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$router.push('/questionnaire')
      }).catch(() => {
        this.tipAndOpenQuestionnaireModal()
      })
    },
    onClickLoginChange() {
      this.showPwdModal()
    },
    checkPasswordExpireTime(password_expire_time) {
      if (!password_expire_time) {
        this.checkPasswordExpireTimeLimit3Day(3)
      } else {
        let dateNum = this.getDayDiff(password_expire_time)

        if (dateNum > 0 && dateNum <= 3) {
          dateNum = Math.ceil(dateNum)
          this.checkPasswordExpireTimeLimit3Day(dateNum)
        }
        if (dateNum <= 0) {
          this.checkPasswordExpireTimeMustModify()
        }
      }
    },
    getDayDiff(password_expire_time) {
      if (password_expire_time) {
        const date1 = (new Date()).getTime()
        const date2 = (new Date(password_expire_time + '')).getTime()
        return (date2 - date1) / (1000 * 60 * 60 * 24) // 相减得出的毫秒数除以毫秒除以1分钟60秒除以1小时60分钟，再除以1天24小时
      }
      return 0
    },
    checkPasswordExpireTimeLimit3Day(dateNum) {
      this.$confirm(`The password will expire in ${dateNum} days, please modify it`, 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.showPwdModal()
      })
    },
    checkPasswordExpireTimeMustModify() {
      this.$confirm('The password has expired, please modify it ', 'Tips', {
        confirmButtonText: 'Confirm',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        this.showPwdModal()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .line-bottom-1px{
    margin-top: 40px;
    border-bottom: 1px solid #D3D7DF;
  }

</style>
